module.exports = "<h2 class=\"tmb-title\">Account Payment</h2>\r\n<div class=\"account-payment\">\r\n  <list-invoice #invoice [patientId]='patientId' [payinvoice]='payInvoice'></list-invoice>\r\n  <pay-invoice #payinvoice [listinvoice]='listInvoice'></pay-invoice>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/payment/account-payment/account-payment.component.html
// module id = ../../../../../src/app/pages/payment/account-payment/account-payment.component.html
// module chunks = main